import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import { PropsWithChildren, useRef, useState } from "react";
import Shadow from "react-shadow";

import FontFace from "../components/theme/FontFace";
import themeConfig from "../lib/themeConfig";

const StyleWrapper = ({
  children,
  theme,
}: PropsWithChildren<{ theme?: string }>) => {
  const [_loaded, setLoaded] = useState(false);
  const styleRef = useRef<HTMLDivElement | null>(null);

  if (theme === "inline") {
    return (
      <ThemeProvider
        theme={createTheme({
          ...themeConfig,
          embedded: true,
          name: theme,
        })}
      >
        {children}
      </ThemeProvider>
    );
  }

  const muiTheme = createTheme({
    ...themeConfig,
    embedded: true,
    name: theme ?? "default",
    cssVariables: {
      rootSelector: ":host",
      colorSchemeSelector: "class",
    },
    components: {
      ...themeConfig.components,
      MuiPopover: {
        defaultProps: {
          container: styleRef.current,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: styleRef.current,
        },
      },
      MuiModal: {
        defaultProps: {
          container: styleRef.current,
        },
      },
    },
  });

  return (
    <>
      <FontFace />
      <Shadow.div>
        <Box
          ref={(inst: HTMLDivElement) => {
            setLoaded(true);
            styleRef.current = inst;
          }}
        >
          {styleRef.current && (
            <CacheProvider
              value={createCache({
                key: "widget",
                prepend: true,
                container: styleRef.current,
              })}
            >
              <ThemeProvider theme={muiTheme}>
                <Box
                  sx={{
                    all: "initial",
                    "& .widget-wrapper": {
                      padding: "1em",
                      backgroundColor: muiTheme.palette.background.default,
                      borderRadius: "0.3em",
                    },
                  }}
                >
                  <Box>{children}</Box>
                </Box>
              </ThemeProvider>
            </CacheProvider>
          )}
        </Box>
      </Shadow.div>
    </>
  );
};

export default StyleWrapper;
